<template lang="pug">
  ods-dropdown(
    :hide-on-click='false'
    icon='setting'
    @visible-change='handleVisibleChange')
    ods-dropdown-menu.popover-columns.desplegable(slot='dropdown')
      h3.titulosetting {{ $t('msg_generics.filter_table_menu') }}
      ods-dropdown-item(
        v-for='(column, index) in columns',
        :key='index')
        ods-checkbox(
          @input='handlerShowColumns(column)',
          v-model='column.show')
          | {{ column.text }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'b2b-table-lines-recadvs-emit',
  props: [],
  data () {
    return {
      columns: [],
      column: {}
    }
  },

  computed: {
    ...mapGetters([
      'isShowCodeLinesEmit',
      'isShowItemCodeSellerRecadvLinesEmit',
      'isShowItemCodeBuyerRecadvLinesEmit',
      'isShowDescriptionRecadvLinesEmit',
      'isShowOrderLinesEmit',
      'isShowDeliveryNoteNumberRecadvLinesEmit',
      'isShowDeliveryNoteLineRecadvLinesEmit',
      'isShowDespatchQuantityLinesEmit',
      'isShowReceivedQuantityLinesEmit',
      'isShowAcceptedQuantityLinesEmit',
      'isShowMeasureRecadvLinesEmit',
      'isShowPriceLinesEmit',
      'isShowCurrencyRecadvLinesEmit',
      'isShowStatusRecadvLinesEmit',
      'isShowSubtypeRecadvLinesEmit'
    ])
  },

  methods: {
    ...mapActions([
      'isShowCodeLinesEmitAction',
      'isShowItemCodeSellerRecadvLinesEmitAction',
      'isShowItemCodeBuyerRecadvLinesEmitAction',
      'isShowDescriptionRecadvLinesEmitAction',
      'isShowOrderLinesEmitAction',
      'isShowDeliveryNoteNumberRecadvLinesEmitAction',
      'isShowDeliveryNoteLineRecadvLinesEmitAction',
      'isShowDespatchQuantityLinesEmitAction',
      'isShowReceivedQuantityLinesEmitAction',
      'isShowAcceptedQuantityLinesEmitAction',
      'isShowMeasureRecadvLinesEmitAction',
      'isShowPriceLinesEmitAction',
      'isShowCurrencyRecadvLinesEmitAction',
      'isShowStatusRecadvLinesEmitAction',
      'isShowSubtypeRecadvLinesEmitAction'
    ]),

    handlerShowColumns (col) {
      console.log('handlerShowColumns en B2bTable: ', col)
      const column = col.value
      let isShow
      switch (column) {
        case 'code':
          isShow = !this.isShowCodeLinesEmit
          this.isShowCodeLinesEmitAction(isShow)
          break
        case 'itemCodeSeller':
          isShow = !this.isShowItemCodeSellerRecadvLinesEmit
          this.isShowItemCodeSellerRecadvLinesEmitAction(isShow)
          break
        case 'itemCodeBuyer':
          isShow = !this.isShowItemCodeBuyerRecadvLinesEmit
          this.isShowItemCodeBuyerRecadvLinesEmitAction(isShow)
          break
        case 'description':
          isShow = !this.isShowDescriptionRecadvLinesEmit
          this.isShowDescriptionRecadvLinesEmitAction(isShow)
          break
        case 'order':
          isShow = !this.isShowOrderLinesEmit
          this.isShowOrderLinesEmitAction(isShow)
          break
        case 'deliveryNoteNumber':
          isShow = !this.isShowDeliveryNoteNumberRecadvLinesEmit
          this.isShowDeliveryNoteNumberRecadvLinesEmitAction(isShow)
          break
        case 'deliveryNoteLine':
          isShow = !this.isShowDeliveryNoteLineRecadvLinesEmit
          this.isShowDeliveryNoteLineRecadvLinesEmitAction(isShow)
          break
        case 'despatchQuantity':
          isShow = !this.isShowDespatchQuantityLinesEmit
          this.isShowDespatchQuantityLinesEmitAction(isShow)
          break
        case 'receivedQuantity':
          isShow = !this.isShowReceivedQuantityLinesEmit
          this.isShowReceivedQuantityLinesEmitAction(isShow)
          break
        case 'acceptedQuantity':
          isShow = !this.isShowAcceptedQuantityLinesEmit
          this.isShowAcceptedQuantityLinesEmitAction(isShow)
          break
        case 'measure':
          isShow = !this.isShowMeasureRecadvLinesEmit
          this.isShowMeasureRecadvLinesEmitAction(isShow)
          break
        case 'price':
          isShow = !this.isShowPriceLinesEmit
          this.isShowPriceLinesEmitAction(isShow)
          break
        case 'currency':
          isShow = !this.isShowCurrencyRecadvLinesEmit
          this.isShowCurrencyRecadvLinesEmitAction(isShow)
          break
        case 'status':
          isShow = !this.isShowStatusRecadvLinesEmit
          this.isShowStatusRecadvLinesEmitAction(isShow)
          break
        case 'subtype':
          isShow = !this.isShowSubtypeRecadvLinesEmit
          this.isShowSubtypeRecadvLinesEmitAction(isShow)
          break
        default:
          break
      }
    },
    handleVisibleChange () {
      this.chargeFilters()
    },
    chargeFilters () {
      this.columns = [
        {
          text: this.$t('recadv.recadv_entity_table_detail.code'), value: 'code', show: this.isShowCodeLinesEmit
        }, {
          text: this.$t('recadv.recadv_entity_table_detail.itemCodeSeller'), value: 'itemCodeSeller', show: this.isShowItemCodeSellerRecadvLinesEmit
        }, {
          text: this.$t('recadv.recadv_entity_table_detail.itemCodeBuyer'), value: 'itemCodeBuyer', show: this.isShowItemCodeBuyerRecadvLinesEmit
        }, {
          text: this.$t('recadv.recadv_entity_table_detail.description'), value: 'description', show: this.isShowDescriptionRecadvLinesEmit
        }, {
          text: this.$t('recadv.recadv_entity_table_detail.order'), value: 'order', show: this.isShowOrderLinesEmit
        }, {
          text: this.$t('recadv.recadv_entity_table_detail.deliveryNoteNumber'), value: 'deliveryNoteNumber', show: this.isShowDeliveryNoteNumberRecadvLinesEmit
        }, {
          text: this.$t('recadv.recadv_entity_table_detail.deliveryNoteLine'), value: 'deliveryNoteLine', show: this.isShowDeliveryNoteLineRecadvLinesEmit
        }, {
          text: this.$t('recadv.recadv_entity_table_detail.despatch_quantity'), value: 'despatchQuantity', show: this.isShowDespatchQuantityLinesEmit
        }, {
          text: this.$t('recadv.recadv_entity_table_detail.received_quantity'), value: 'receivedQuantity', show: this.isShowReceivedQuantityLinesEmit
        }, {
          text: this.$t('recadv.recadv_entity_table_detail.accepted_quantity'), value: 'acceptedQuantity', show: this.isShowAcceptedQuantityLinesEmit
        }, {
          text: this.$t('recadv.recadv_entity_table_detail.measure'), value: 'measure', show: this.isShowMeasureRecadvLinesEmit
        }, {
          text: this.$t('recadv.recadv_entity_table_detail.price'), value: 'price', show: this.isShowPriceLinesEmit
        }, {
          text: this.$t('recadv.recadv_entity_table_detail.currency'), value: 'currency', show: this.isShowCurrencyRecadvLinesEmit
        }, {
          text: this.$t('recadv.recadv_entity_table_detail.status'), value: 'status', show: this.isShowStatusRecadvLinesEmit
        }, {
          text: this.$t('recadv.recadv_entity_table_detail.subtype'), value: 'subtype', show: this.isShowSubtypeRecadvLinesEmit
        }
      ]
    }
  },
  created () {
    this.chargeFilters()
  }
}
</script>

<style lang="scss" scoped>
.desplegable {
    top: 180px !important
}
.titulosetting {
      padding: 10px;
}
</style>
